module.exports = __webpack_public_path__ + "img/arrow-back.ab3faca7.svg";